import type { CorrectionScope, Department } from "../../../api/api";
import type { InvoiceSellerId, OrderPriceByDepartmentResponse } from "../ordersApi";

export const AUTOMATIC_SELLER_SELECTION = "AUTOMATIC" as const;

export type SellerSelection = InvoiceSellerId | typeof AUTOMATIC_SELLER_SELECTION;

export function buildCorrectionScopeFromSeller(seller: SellerSelection): CorrectionScope {
  if (seller === "PRZEZMORZE") {
    return { departments: ["MARITIME_TRANSPORT"] };
  }
  if (seller === "B2B_HOTELS") {
    return { departments: ["HOTEL", "ATTRACTION"] };
  }
  return {};
}

export function resolveDepartmentForSeller(
  sellerId: InvoiceSellerId,
  value: number,
  invoiceKind: "advance" | "proforma",
  priceByDepartment: OrderPriceByDepartmentResponse,
): Department | undefined {
  const sellerLimits = priceByDepartment[invoiceKind][sellerId];
  if (!sellerLimits) {
    return undefined;
  }

  if (sellerId === "PRZEZMORZE") {
    return "MARITIME_TRANSPORT";
  }

  for (const department of priceByDepartment.departmentAssignmentOrder) {
    if (!sellerLimits.seller.departments.includes(department)) {
      continue;
    }
    const departmentLimits = sellerLimits.byDepartment[department];
    if (departmentLimits && value <= departmentLimits.availableAmount) {
      return department;
    }
  }

  return undefined;
}
